import { requireAuth } from './auth';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export async function createProject() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/PostNewProjectByUserId`);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const res = await response.json();
    if (!response.ok || res?.code !== 200 || !res?.data?.project_id) {
        console.error('createProject failed', res);
        throw new Error(res?.message || `Failed to create project: HTTP ${response.status}`);
    }
    return res.data;
}

export async function getProjectsByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/GetProjectsByUserId`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function modifyProjectName(projectId, projectName) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/UpdateProject`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('projectName', projectName);
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    console.log('modifyProjectName', data)
    if (!response.ok || data?.code !== 200) {
        throw new Error(data?.message || `Failed to modify project: HTTP ${response.status}`);
    }
    return data;
}

export async function deleteProject(projectId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/DeleteProject`);
    url.searchParams.append('projectId', projectId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function getPagesByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/GetPagesByUserId`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function createPageByUserId(projectId, parentPageId = "None") {

    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/PostNewPageByUserId`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('parentPageId', parentPageId);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    console.log(data);
    return data;
}

export async function modifyPageName(projectId, pageId, pageName) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/UpdatePage`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId', pageId);
    url.searchParams.append('pageName', pageName);
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function deletePageByUserId(projectId, pageId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/DeletePage`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId', pageId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}
export async function swapPageOrder(projectId, pageId1, pageId2) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/SwapPageOrder`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId1', pageId1);
    url.searchParams.append('pageId2', pageId2);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    console.log(data)
    return data;
}

export async function getLinesByUserId() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/GetLinesByUserId`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function createLineByUserId(projectId, pageId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/PostNewLineByUserId`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId', pageId);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function updateLineByUserId(
    projectId, pageId, lineId, text, audioFileId, voiceSettings
) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/PostNewLineByUserId`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId', pageId);
    url.searchParams.append('lineId', lineId);
    url.searchParams.append('text', text);
    url.searchParams.append('audioFileId', audioFileId);
    url.searchParams.append('voiceSettings', JSON.stringify(voiceSettings));
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function updateLinesByPage(params) {
    if (!await requireAuth()) { return }
    console.log(params);
    const authToken = localStorage.getItem('auth_token')
    const url = `${baseURL}/projects/UpdateLinesAllPage`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify(params),
    });
    const data = await response.json();
    return data;
}

export async function deleteLineByUserId(projectId, pageId, lineId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/projects/DeleteLine`);
    url.searchParams.append('projectId', projectId);
    url.searchParams.append('pageId', pageId);
    url.searchParams.append('lineId', lineId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}
